export default {
  logging: 'Iniciando sesión...',
  logCall: 'Registrar llamada',
  editLog: 'Editar registro',
  select: 'Seleccionar una grabación que coincida',
  OnHold: 'En espera',
  Ringing: 'Llamando',
  CallConnected: 'Llamada conectada',
  unknownUser: 'Usuario desconocido',
  unknownNumber: 'Anónimo',
  unavailable: 'No disponible',
  viewDetails: 'Ver detalles',
};
